<template>
  <div>
    <div style="margin-bottom:.1rem">
      <!-- <div class="header" v-if="typeData">
        <van-tabs v-model="active" animated color="#008AFF" class="tab-warpper" @change="onChange" line-width="10%">
          <van-tab v-for="(item,index) of typeData" :key="index" :title="item.pageName"></van-tab>
        </van-tabs>
      </div>
      <van-row class="headerKind" v-if="kindData">
        <van-col span="8" v-for="(item,index) of kindData" :key="index" :class="{ kindClass:item.pageCode===kindNum }"><span @click="changeKind(index)">{{item.pageName}}</span></van-col>
      </van-row> -->
    </div>
    <home-commonbg class="showImg" v-if="loadFlag"></home-commonbg>
  </div>
</template>

<script>
import HomeCommonbg from '../../common/commonBg'
import { postAction, getAction } from '@/utils/api'

export default {
  name: 'HomeHeader',
  components: {
    HomeCommonbg
  },
  data () {
    return {
      typeData: [],
      kindData: [],
      kindNum: null,
      kindName: '',
      active: 0,
      swiperList: [],
      swiperListResult: [],
      quotaCard: null,
      loadFlag: true,
      getData: [],
      stopFlag: false,
      indexId: '',
      indexurl: '/simpapp/performance/getYeJiIndexCard',
      selectedKindData: '', // 保存当前选中的二级菜单的数据
      selectedKindDataIndex: 0
    }
  },
  methods: {
    getHomeInfo () {
      this.loadFlag = true
      var url = '/performance/menu/menuApi'
      let postData = {
        moduleCode: this.$store.state.user.pageCode,
        userAccount: this.$store.state.user.account
      }
      var obj = postAction(url, postData)
      obj.then(res => {
        this.getData = res.data.menuInfo
        this.dealData = res.data.menuInfo
        this.typeData = this.dealData
        // 此处如果不是直接跳进来的方法需要通过store中已经保存的历史数据保留当前页面的状态
        this.setCurrentPageVarStatus()
        // 请求swiper数据
        this.swiperList = this.selectedKindData.indexs
        // 获取swiper具体指标的前面方法
        this.getSwiperDataPreMethod()
      })
    },
    /*
    * 设置当前页面变量的状态值
    */
    setCurrentPageVarStatus () {
      if (this.$store.state.entirety.type !== '' && this.$store.state.entirety.type !== undefined && !this.$store.state.user.headerFlag) {
        // 保存数据到store中
        this.active = this.$store.state.entirety.headerSelect1Active
        this.typeNum = this.typeData[this.active].pageCode
        this.kindData = this.typeData[this.active].child && this.typeData[this.active].child.length === 0 ? new Array(this.typeData[this.active]) : this.typeData[this.active].child
        this.kindNum = this.$store.state.entirety.kind
        let flag = this.getSelectedKindDataIndex()
        this.selectedKindData = this.kindData[flag] // 二级数据
        this.channelData = this.selectedKindData.salechnl // 三级所有的数据
        this.channelNum = this.channelData[0].dataSalechnlCode
      } else {
        this.typeNum = this.typeData[this.active].pageCode
        this.kindData = this.typeData[this.active].child && this.typeData[this.active].child.length === 0 ? new Array(this.typeData[this.active]) : this.typeData[this.active].child
        let flag = this.getSelectedKindDataIndex()
        this.selectedKindData = flag !== false ? this.kindData[flag] : this.kindData[this.selectedKindDataIndex]
        this.kindNum = this.selectedKindData.pageCode
        this.channelData = this.selectedKindData.salechnl
        this.channelNum = this.channelData[0].dataSalechnlCode
        this.saveVuexStoreData(this.selectedKindData)
      }
    },
    /*
    * 设置将部分数据保存到store中vuex中
    */
    saveVuexStoreData (selectedKindData) {
      this.$store.commit('ENTIRETY_SET_HeaderSelect1Active', this.active)
      this.$store.commit('ENTIRETY_SET_TYPE', this.typeNum)
      this.$store.commit('ENTIRETY_SET_TYPE_NAME', this.typeData[this.active].pageName)
      this.$store.commit('ENTIRETY_SET_KIND', this.kindNum)
      // 判断是否有选中的状态没有的话默认选择数据中的第一个为默认选中状态
      if (selectedKindData) {
        this.$store.commit('ENTIRETY_SET_KIND_NAME', selectedKindData.pageName)
      } else {
        this.$store.commit('ENTIRETY_SET_KIND_NAME', this.kindData[0].pageName)
      }
      this.$store.commit('ENTIRETY_SET_CHANNEL', this.channelNum)
      this.$store.commit('ENTIRETY_SET_CHANNEL_NAME', this.channelData[0].salechnlName)
    },
    postGet (indexurl, postindexData, length) {
      return new Promise((resolve, reject) => {
        var indexobj = postAction(indexurl, postindexData)
        indexobj.then(response => {
          if (response.data) {
            var getPostdata = {
              moduleId: this.$store.state.user.pageCode,
              indexId: response.data.indexId,
              channelId: this.$store.state.entirety.channel,
              date: ''
            }
            var getFlag = getAction('/performance/dimension/showDimension', getPostdata)
            getFlag.then(res => {
              response.data.currateShow = res.data.hasAchievementRate
              this.swiperListResult.push(response.data)
              if (this.swiperListResult.length === length) {
                this.setSwiperListdata(this.swiperListResult)
                this.stopFlag = true
                this.loadFlag = false
              }
            })
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取当前选中的kindData数据
    // 判断当hasOldData是true的时候代表有老值否则采用
    getSelectedKindDataIndex () {
      for (var i = 0; i < this.kindData.length; i++) {
        if (this.kindNum === this.kindData[i].pageCode) {
          return i
        }
      }
      return false
    },
    changeKind (index) {
      this.selectedKindDataIndex = 0
      this.loadFlag = true
      this.kindNum = this.kindData[index].pageCode
      this.channelData = this.kindData[index].salechnl
      this.channelNum = this.channelData[0].dataSalechnlCode
      this.selectedKindData = this.kindData[index]
      // 保存选中的数据到store的vuex中
      this.saveVuexStoreData(this.selectedKindData)
      // this.$store.commit('ENTIRETY_SET_KIND', this.kindNum)
      // this.$store.commit('ENTIRETY_SET_KIND_NAME', this.kindData[index].pageName)
      // this.$store.commit('ENTIRETY_SET_CHANNEL', this.channelNum)
      // this.$store.commit('ENTIRETY_SET_CHANNEL_NAME', this.channelData[0].salechnlName)
      this.swiperList = this.kindData[index].indexs
      // 获取swiper具体指标的前面方法
      this.getSwiperDataPreMethod()
    },
    // 当typeData数据tab的active改变是时候进行的函数
    onChange (index) {
      this.selectedKindDataIndex = index
      this.loadFlag = true
      this.typeNum = this.typeData[this.active].pageCode
      this.kindData = this.typeData[this.active].child
      this.kindNum = this.kindData[0].pageCode
      this.channelData = this.kindData[0].salechnl
      this.channelNum = this.channelData[0].dataSalechnlCode
      // 保存选中的数据到store的vuex中
      this.saveVuexStoreData(this.selectedKindData)
      this.$store.commit('ENTIRETY_SET_TYPE', this.typeNum)
      this.$store.commit('ENTIRETY_SET_TYPE_NAME', this.typeData[this.selectedKindDataIndex].pageName)
      this.$store.commit('ENTIRETY_SET_KIND', this.kindNum)
      this.$store.commit('ENTIRETY_SET_KIND_NAME', this.kindData[0].pageName)
      this.$store.commit('ENTIRETY_SET_CHANNEL', this.channelNum)
      this.$store.commit('ENTIRETY_SET_CHANNEL_NAME', this.channelData[0].salechnlName)
      this.swiperList = this.kindData[0].indexs
      // 获取swiper具体指标的前面方法
      this.getSwiperDataPreMethod()
    },
    // 通过请求回来的swiper中数据的id获取保费或达成率等指标的前面的操作方法
    getSwiperDataPreMethod () {
      this.swiperListResult = []
      this.stopFlag = false
      // 个险模块大区接口地址特殊判断
      if (this.$store.state.user.pageCode === '02' && this.$store.state.user.areaFlag === '1') {
        this.indexurl = '/simpapp/performance/getYeJiAreaIndexCard'
      } else {
        this.indexurl = '/simpapp/performance/getYeJiIndexCard'
      }
      for (let i = 0; i < this.swiperList.length; i++) {
        var postindexData = {
          'channelId': this.channelNum,
          'classification': this.kindNum,
          'date': '',
          'indexId': new Array(this.swiperList[i].indexCode),
          'level': this.$store.state.user.level,
          'orgId': this.$store.state.user.orgId,
          'rank': this.swiperList[i].rank
        }
        this.postGet(this.indexurl, postindexData, this.swiperList.length)
      }
    },
    // 将swiper数据发送给swiper组件
    setSwiperListdata () {
      this.$emit('getswiper', JSON.parse(JSON.stringify(this.swiperListResult)))
    }
  },
  computed: {
    pageCode () {
      return this.$store.state.user.pageCode
    }
  },
  watch: {
    loadFlag () {
      this.$nextTick(() => {
        if (this.loadFlag) {
          this.$emit('postrefresh', true)
        } else {
          this.$emit('postrefresh', false)
        }
      })
    },
    pageCode: {
      handler: function (val, oldVal) {
        this.getHomeInfo()
      },
      deep: true
    }
  },
  mounted () {
    this.$store.commit('ENTIRETY_SET_PAGEFLAG', 1)
    localStorage.setItem('pageFlag', 1)
    this.getHomeInfo()
  }
}
</script>

<style lang="stylus" scoped>
  .header >>> .van-tab span {
    font-size: .16rem;
    line-height: 3;
    font-weight: 400;
    color: #333
    // font-family:SFUIText-Medium;
  }

  .header >>> .van-tab--active span {
    font-size: 0.18rem;
    color: #008AFF;
    font-weight: 600;
  }

  .header >>> .van-tabs__nav--line {
    padding-bottom: 0rem;
  }

  .header >>> .van-tabs__line {
    bottom: 0;
    border-radius: 100px 100px 0px 0px;
  }

  .header >>> .van-tabs--line .van-tabs__wrap {
    height: auto;
  }

  .header {
    background: #fff;
    display: flex;
    width: 100%;
    min-height:.48rem;
    // border-bottom: 1px solid #ececec;
    border-bottom: 1px solid #ECECEC;
  }

  .header >>> .van-tab {
    // flex: none;
    flex-basis: 50%;
  }

  .tab-warpper {
    width: 100%;
  }

  .tab-warpper .nav-title {
    font-size: 5rem;
    color: red;
  }

  .plan {
    background: #fff;
    color: #3399FF;
    font-size: .16rem;
    padding-left: .2rem;
    line-height 2.5;
  }

  .header >>> .van-hairline--top-bottom::after {
    border-width: 0;
  }

  .headerKind {
    width 100%;
    min-height:.4rem
    background: #fff;
    font-size: .14rem;
    text-align: center;
    line-height: .4rem
  }

  .kindClass {
    color: #3399FF;
  }
  .showImg{
    position flex
    z-index 1000
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/Header.vue